import { ClipsPage, ClipViewPage } from "../../pages/clips";

export const routeClips = "/clips";
export const routeClipView = "/clips/view";

export const clipsRoutes = [
	{
		path: routeClips,
		element: <ClipsPage />,
	},
	{
		path: "/clips/:clipId",
		element: <ClipsPage />,
	},
	{
		path: routeClipView,
		element: <ClipViewPage />,
	},
	{
		path: "/clips/view/:clipId",
		element: <ClipViewPage />,
	},
];
